// extracted by mini-css-extract-plugin
export default {"welcomeScreen":"welcome-screen_welcomeScreen__TAo9o"};